import React from "react";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";

import {
    StyledHr,
    StyledFilterData,
    StyledFilterCell,
} from "../../../styles/pages/AdministratorTach/FilterTachStyles";
import { StyledP } from "../../../styles/MainStyles";

import ButtonFilterTach from "./ButtonFilterTach";
import SelectStatusTach from "./SelectStatusTach";
import ModalSelectDataTach from "../Modal/SelectDataTach/ModalSelectDataTach";
import { useFilterData } from "../../../context/TachContext/FilterDataContext";
import { IFilter } from "../../../context/interfaces/IFilterDataContext";

interface IFilterData {
    isGenerate: boolean;
}

const FilterData: React.FC<IFilterData> = ({ isGenerate }) => {
    const { filterGenerate, filterPage } = useFilterData();

    const filter: IFilter = isGenerate ? filterGenerate : filterPage;

    const hasSelectedCampus = !!filter.campus.selectedValue.length;
    const hasSelectedSchool = !!filter.school.selectedValue.length;
    const hasSelectedModality = !!filter.modality.selectedValue.length;
    const hasSelectedCourse = !!filter.course.selectedValue.length;
    const hasSelectedProfessor = !!filter.professor.selectedValue.length;

    const isBlockedToSelectCampus = hasSelectedProfessor;
    const isBlockedToSelectProfessor =
        hasSelectedCampus && hasSelectedCourse.valueOf() === false;

    return (
        <>
            <StyledFilterData>
                <StyledFilterCell>
                    <StyledP>Campus:</StyledP>
                    <ButtonFilterTach
                        text="Campus"
                        referenceKey="campus"
                        disabled={isBlockedToSelectCampus}
                        hasContent={hasSelectedCampus}
                        isGenerate={isGenerate}
                    />
                </StyledFilterCell>
                <StyledHr />
                <StyledFilterCell>
                    <StyledP>Escola:</StyledP>
                    <ButtonFilterTach
                        text="Escola"
                        referenceKey="school"
                        disabled={!hasSelectedCampus}
                        hasContent={hasSelectedSchool}
                        isGenerate={isGenerate}
                    />
                </StyledFilterCell>
                <StyledHr />
                <StyledFilterCell>
                    <StyledP>Modalidade:</StyledP>
                    <ButtonFilterTach
                        text="Modalidade"
                        referenceKey="modality"
                        disabled={!hasSelectedSchool}
                        hasContent={hasSelectedModality}
                        isGenerate={isGenerate}
                    />
                </StyledFilterCell>
                <StyledHr />
                <StyledFilterCell>
                    <StyledP>Curso:</StyledP>
                    <ButtonFilterTach
                        text="Curso"
                        referenceKey="course"
                        disabled={!hasSelectedModality}
                        hasContent={hasSelectedCourse}
                        isGenerate={isGenerate}
                    />
                </StyledFilterCell>
                <StyledHr />
                <StyledFilterCell>
                    <StyledP>Professor:</StyledP>
                    <ButtonFilterTach
                        text="Professor"
                        referenceKey="professor"
                        disabled={isBlockedToSelectProfessor}
                        hasContent={hasSelectedProfessor}
                        isGenerate={isGenerate}
                    />
                </StyledFilterCell>
                {!isGenerate && (
                    <>
                        <StyledHr />
                        <StyledFilterCell>
                            <StyledP>Status Workflow:</StyledP>
                            <SelectStatusTach />
                        </StyledFilterCell>
                    </>
                )}
            </StyledFilterData>
            {filter.openModal && (
                <ModalSelectDataTach
                    isOpen={filter.openModal}
                    isGenerate={isGenerate}
                />
            )}
        </>
    );
};

export default FilterData;
